import React, { useEffect, useState } from 'react'
import styles from './news.module.css'
import calendar from '../../assets/icons/calendar.svg'
import eye from '../../assets/icons/eye.svg'
import person from '../../assets/icons/person.svg'
import DOMPurify from 'dompurify';
import { Box } from '@mui/material'
import * as api from '../services/api'
import Loader from 'components/Loader'

function ShowNews() {
    const [loading, setLoading] = useState(false)

    const [news, setNews] = useState([])

    useEffect(() => {
        let searchParams = new URLSearchParams(window.location.search).get("code")
        findNews(searchParams)
    }, [])

    const findNews = async (code) => {
        setLoading(true)
        let res = await api.findNewsCodeFixToken(code)
        setLoading(false)
        if (res) {
            if (res['data']['code'] === 200) {
                // let list = res['data']['data']
                // let option = []
                // list.map(i => {
                //     if (code === i['new_code']) {
                //         option.push(i)
                //     }
                // })
                // const unique = [...new Map(option.map((m) => [m.new_code, m])).values()] //กรองชื่อซ้ำ
                // setNews(unique)
                setNews(res['data']['data'])
            } else {
                //alert(res['data']['message'])
            }
        } else {
            alert('ไม่ตอบสนอง')
        }
    }

    const convertDate = (dataDate) => {
        const date = new Date(dataDate)
        const optionDate = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        }
        const thaiLocale = 'th-TH';
        const formattedDate = date.toLocaleDateString(thaiLocale, optionDate)

        const newDate = `${formattedDate}`
        return newDate
    }

    const sanitizeHTML = (html) => {
        return DOMPurify.sanitize(html, {
            ALLOWED_TAGS: ['a', 'img', 'p', 'h1', 'h2', 'strong', 'em', 'u', 'br', 'div', 'span', 'ul', 'ol', 'li', 'b', 'i', 'video','source', 'iframe'],
            ALLOWED_ATTR: ['href', 'src', 'alt', 'title', 'style', 'target', 'rel', 'autoplay', 'loop', 'muted', 'allowfullscreen'],
            ADD_TAGS: ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
            ALLOWED_CLASSES: ['ql-align-center', 'ql-align-left', 'ql-align-right']
        });
    };


    return (
        <>
            <Loader loading={loading} />
            <Box sx={{
                border: '1px solid #C1DDFF',
                padding: '20px 40px',
                margin: '30px',
                display: 'grid',
                gridGap: '10px',
                "@media (max-width: 800px)": {
                    padding: '10px',
                    margin: '10px'
                },
            }} >
                <Box className={styles.containerImg}>
                    <img src={news['images']} className={styles.imgHeader2} />
                </Box>
                <Box className={styles.header_show}>บทความสำคัญ: {news['new_title']}</Box>
                <Box className={styles.title_show}>
                    <Box sx={{ display: 'flex', gridGap: '5px' }}>
                        <img src={person} />
                        <Box>BY ADMIN</Box>
                    </Box>
                    <Box sx={{ display: 'flex', gridGap: '5px' }}>
                        <img src={calendar} />
                        <Box>{convertDate(news['created_date'])}</Box>
                    </Box>
                    <Box sx={{ display: 'flex', gridGap: '5px' }}>
                        <img src={eye} />
                        <Box>จำนวนผู้เข้าชม <span style={{ color: '#000000' }}>{news['views_total']?.toLocaleString()}</span></Box>
                    </Box>
                </Box>
                <Box
                    sx={{ padding: 4 }}
                    className={styles.detail_show}
                    dangerouslySetInnerHTML={{ __html: sanitizeHTML(news['new_detail']) }}
                />
            </Box>
        </>
    )
}

export default ShowNews
